import { makeStyles, shorthands } from '@fluentui/react-components';

export const useDropdownTreeStyles = makeStyles({
  root: {
    position: 'relative',
    // 'max-width': '400px',
  },
  dropdownContent: {
    position: 'absolute',
    width: '100%',
    display: 'block',
    zIndex: 1,
    maxHeight: '500px',
    'box-sizing': 'border-box',
    'background-color': 'white',
    'border-radius': '4px',
    'box-shadow': '0 0 2px rgba(0,0,0,0.12), 0 8px 16px rgba(0,0,0,0.14)',
    ...shorthands.padding('4px'),
    ...shorthands.overflow('auto'),
  },
  branch: {
    fontWeight: 600,
  },
  hideContent: {
    display: 'none',
  },
  noResults: {
    ...shorthands.padding('8px'),
    'font-size': '14px',
    'font-weight': '400',
    'line-height': '20px',
    color: '#323130',
  },
  treeItemLayout: {
    '& .fui-TreeItemLayout__main': {
      ...shorthands.flex(1),
    },
  },
});
